import request from "@/util/request.js";
export const getStatisticsApi = (params) =>
  request({
    url: `/oms/saas/accounts/getWeChatStat`,
    method: "GET",
    params,
  });
